/**
 * Compatible scrollTo method.
 * Fallback to scrollTop when scrollTo() method is not supported by browser
 */

type ScrollElement = HTMLElement | undefined | null;

export function scrollTo(elm: ScrollElement, options: ScrollToOptions): void;
export function scrollTo(elm: ScrollElement, left: number, top: number): void;
export function scrollTo(
  elm: ScrollElement,
  left: ScrollToOptions | number,
  top: number = 0,
): void {
  if (!elm) return;
  if (elm.scrollTo) {
    return typeof left === 'object'
      ? elm.scrollTo(left)
      : elm.scrollTo(left, top);
  }

  const { top: scrollTop, left: scrollLeft } =
    typeof left === 'object' ? left : { top, left };

  if (scrollTop) elm.scrollTop = scrollTop;
  if (scrollLeft) elm.scrollLeft = scrollLeft;
}
